module.exports = __webpack_public_path__ + "static/img/news10.0df6715.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/news10.png
// module id = geRG
// module chunks = 52